import React from "react"
import { graphql } from "gatsby"
import {
  Box,
  Container,
  Grid,
  Heading,
  Text,
  List,
  Image,
  Flex,
} from "@theme-ui/components"
import Layout from "../components/layout"
import { getProductPath } from "../utils/path"
import { HelmetDatoCms } from "gatsby-source-datocms"
import PageHero from "./pageHero"
import { GatsbyImage } from "gatsby-plugin-image"
import { StructuredText } from "react-datocms"
import ImageBlock from "../components/blocks/image"
import QuoteBlock from "../components/blocks/quote"
import { InboundLink } from "../components/link"
import { useBreakpointIndex } from "@theme-ui/match-media"
import { getPagePath } from "../utils/path"
import { i18nContext } from "../context/i18nContext"
import ArrowLeft from "../images/arrow-left-primary.svg"
import Quote from "../images/quote.svg"

import { useColorMode } from "theme-ui"
import {
  isHeading,
  isParagraph,
  isList,
  renderRule,
} from "datocms-structured-text-utils"
const Page = ({
  data: { page, site, footer, menu, partner, projectPage },
  location,
  pageContext,
}) => {
  const breakpointIndex = useBreakpointIndex()
  const locale = pageContext.locale
  console.log(locale)
  const pageCategory =
    location.state && location.state.category
      ? page.category[
          page.category.findIndex(({ title }) => {
            return title === location.state.category
          })
        ]
      : page.category

  const pageAllSlugLocales = page._allSlugLocales.sort(function (a, b) {
    return site.locales.indexOf(a.locale) - site.locales.indexOf(b.locale)
  })

  const i18nPaths = pageAllSlugLocales.map(locale => {
    return {
      locale: locale.locale,
      value: getProductPath(page, locale.locale),
    }
  })
  const colorMode = useColorMode()
  console.log(colorMode)

  return (
    <Layout
      partner={partner}
      locale={locale}
      i18nPaths={i18nPaths}
      menuData={menu.nodes}
      footerData={footer.nodes}
    >
      <HelmetDatoCms seo={page.seoMetaTags}>
        <html lang={page.locale} />
      </HelmetDatoCms>
      <Container variant="fw">
        <Grid columns={[1, 2]} gap={[3]} sx={{ pt: [5, 5, 5, 7] }}>
          <Box>
            <i18nContext.Consumer>
              {t => (
                <Box
                  sx={{
                    a: {
                      textDecoration: "none",
                    },
                  }}
                >
                  <InboundLink to={getPagePath(projectPage, locale)}>
                    <Flex
                      sx={{
                        justifyContent: "space-between",
                        width: "190px",
                        mb: 5,
                        textTransform: "uppercase",
                        fontFamily: "mono",
                        border: "1px solid",
                        borderRadius: "80px",
                        fontWeight: 500,
                        p: 2,
                        ":hover": {
                          backgroundColor: "secondary",
                        },
                        color: "primary",
                      }}
                    >
                      <Image src={ArrowLeft} />
                      <Text as="p"> {t.seeProjects}</Text>
                    </Flex>
                  </InboundLink>
                </Box>
              )}
            </i18nContext.Consumer>
            <Text
              sx={{
                fontSize: "15px",
                textTransform: "uppercase",
                color: "primary",
              }}
            >
              {page.page.title}
            </Text>
            <Heading
              sx={{
                fontSize: [5, 5, 5, "48px"],
                fontWeight: 500,
                color: "dark",
                width: ["100%", "100%", "60%"],
                h2: {
                  width: "100%!important",
                },
              }}
            >
              {page.title}
            </Heading>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ".gatsby-image-wrapper": {
                borderRadius: "80px",
              },
            }}
          >
            {page.image && page.image.gatsbyImageData && (
              <GatsbyImage
                image={page.image.gatsbyImageData}
                alt={page.title}
                sx={{ maxWidth: "100%" }}
              />
            )}
          </Box>
        </Grid>
      </Container>
      <Container variant="sm">
        <Box
          sx={{
            blockquote: {
              ":before": {
                content: `url(${Quote})`,
                my: 4,
                display: "block",
              },
              m: [0],

              textAlign: "center",
              borderBottom: "3px solid",
              borderColor: "primary",
              pb: [3, 3, 5],
              mb: 5,

              p: {
                lineHeight: ["default", "default", "1.1"],
                fontSize: [2, 3, 3, 4],
                color: "primary",
                "&:last-of-type": {
                  mb: [1],
                  fontSize: [2],
                  mt: [5, 5, 3, 3],
                },
              },
              footer: { color: "primary" },
            },
            h6: {
              textAlign: "center",
              letterSpacing: "0.5",
              mb: 3,
              color: "primary",
              width: "fit-content",
              maxWidth: "fit-content",
              minWidth: "fit-content",
              borderRadius: "40px",
              border: "1px solid",
              borderColor: "primary",
              p: 2,
              fontFamily: "mono",
              px: 3,
              textTransform: "uppercase",
              fontSize: "15px",
              fontWeight: 500,
              fontWeight: 500,
            },
            h5: {
              textAlign: "center",
              letterSpacing: "0.5",
              mb: 3,
              color: "primary",
              width: "fit-content",
              maxWidth: "fit-content",
              minWidth: "fit-content",
              borderRadius: "40px",
              border: "1px solid",
              borderColor: "primary",
              p: 2,
              fontFamily: "mono",
              px: 3,
              textTransform: "uppercase",
              fontSize: "15px",
              fontWeight: 500,
              fontWeight: 500,
            },
            ul: {
              textTransform: "uppercase",
              paddingLeft: 0,
              fontWeight: "bold",
              fontSize: "15px!important",
            },
            li: {
              "::marker": {
                color: "dark",
                px: 3,
                fontSize: "20px!important",
              },

              p: {
                fontSize: "15px!important",
                fontWeight: 500,
                mb: 2,
                ml: 3,
              },

              listStyleType: "'-'",
            },
          }}
        >
          <StructuredText
            data={page.body}
            customNodeRules={[
              renderRule(
                isParagraph,
                ({ adapter: { renderNode }, node, children, key }) => {
                  return renderNode(
                    () => {
                      return (
                        <Text
                          sx={{
                            mt: 0,
                            mb: 5,
                            fontWeight: 400,
                            color: "dark",
                            fontSize: [2, 2, 3],
                          }}
                          as="p"
                          mb={3}
                        >
                          {children}
                        </Text>
                      )
                    },
                    { key },
                    children
                  )
                }
              ),
            ]}
            renderBlock={({ record }) => {
              // console.log(record)
              switch (record.__typename) {
                case "DatoCmsImage":
                  return <ImageBlock colorMode={colorMode} block={record} />
                case "DatoCmsQuote":
                  return <QuoteBlock block={record} />
                default:
                  return null
              }
            }}
          />
        </Box>
      </Container>
    </Layout>
  )
}

export default Page

export const query = graphql`
  query ProductQuery($id: String!, $locale: String!) {
    site: datoCmsSite {
      locales
    }

    menu: allDatoCmsMenu(
      locale: $locale
      filter: { root: { eq: true }, locales: { eq: $locale } }
      sort: { position: ASC }
    ) {
      nodes {
        ...MenuDetails
      }
    }
    projectPage: datoCmsPage(id: { eq: "DatoCmsPage-VeSDOkX4QZ2vcXUkeV4vqg" }) {
      slug
      title
      root
      _allSlugLocales {
        locale
        value
      }
    }

    footer: allDatoCmsFooter(
      locale: $locale
      filter: { root: { eq: true }, locales: { eq: $locale } }
      sort: { position: ASC }
    ) {
      nodes {
        ...FooterDetails
      }
    }
    partner: allDatoCmsPartner {
      ...PartnerFragment
    }
    page: datoCmsProduct(id: { eq: $id }, locale: $locale) {
      id
      ...AllProductSlugLocales
      title
      image {
        gatsbyImageData(
          width: 568

          placeholder: BLURRED
          forceBlurhash: false
        )
      }
      page {
        title
      }
      body {
        value
        blocks {
          __typename
          ... on DatoCmsImage {
            id: originalId
            image {
              alt
              gatsbyImageData
            }
            imageBlack {
              alt
              gatsbyImageData
            }
          }
          ... on DatoCmsQuote {
            id: originalId
            body
          }
        }
      }
      locales
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      category {
        id
        title
        locales
        ...ProductCategoryPageDetails

        categoryImageHero: heroImage {
          desktop: gatsbyImageData(
            placeholder: NONE
            forceBlurhash: false
            imgixParams: {
              blendColor: "#212C30"
              blendMode: "multiply"
              blendAlpha: 30
            }
          )
          mobile: gatsbyImageData(
            placeholder: NONE
            forceBlurhash: false
            imgixParams: {
              fit: "crop"
              ar: "16:10"
              h: "800"
              blendColor: "#212C30"
              blendMode: "multiply"
              blendAlpha: 30
            }
          )
        }
        model {
          apiKey
        }
      }

      model {
        apiKey
      }
    }
    products: allDatoCmsProduct(
      locale: $locale

      sort: { position: ASC }
    ) {
      nodes {
        id
        slug
        locales
        ...AllProductSlugLocales
        title
        category {
          id
          title
          locales
          ...ProductCategoryPageDetails
          model {
            apiKey
          }
        }
      }
    }
  }

  fragment ProductPageDetails on DatoCmsProduct {
    id
    title
    slug

    locales
    model {
      apiKey
    }
  }

  fragment AllProductSlugLocales on DatoCmsProduct {
    _allSlugLocales {
      value
      locale
    }
  }
`
